module.exports = __webpack_public_path__ + "img/sk-partners-trend.5976d174.png";